import { Routes } from '@angular/router';
import { authChildGuard, authGuard } from './features/auth/infrastructure/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  {
    // Onboarding: pantalla de bienvenida sin bottom-navigation (como el login del conductor).
    path: 'welcome',
    loadComponent: () =>
      import('./features/auth/presentation/pages/welcome').then((m) => m.Welcome),
  },
  {
    path: 'registro/verificacion',
    loadComponent: () =>
      import('./features/auth/presentation/pages/verificacion-otp').then((m) => m.VerificacionOtp),
  },
  {
    // Shell con Bottom Navigation persistente: las páginas del tab cuelgan como rutas hijas.
    path: '',
    loadComponent: () =>
      import('./shared/layouts/main-layout/main-layout').then((m) => m.MainLayout),
    canActivateChild: [authChildGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/presentation/pages/home').then((m) => m.Home),
      },
      {
        path: 'viajes',
        loadComponent: () =>
          import('./features/trips/presentation/pages/viajes').then((m) => m.Viajes),
      },
      {
        path: 'viajes/:id',
        loadComponent: () =>
          import('./features/trips/presentation/pages/detalle-viaje').then((m) => m.DetalleViaje),
      },
      {
        path: 'perfil',
        loadComponent: () =>
          import('./features/profile/presentation/pages/perfil').then((m) => m.Perfil),
      },
      {
        path: 'perfil/facturacion',
        loadComponent: () =>
          import('./features/profile/presentation/pages/facturacion').then((m) => m.Facturacion),
      },
      {
        path: 'perfil/metodos-pago',
        loadComponent: () =>
          import('./features/profile/presentation/pages/metodos-pago').then((m) => m.MetodosPago),
      },
      {
        path: 'perfil/configuracion',
        loadComponent: () =>
          import('./features/profile/presentation/pages/configuracion').then(
            (m) => m.Configuracion,
          ),
      },
      {
        path: 'perfil/ayuda',
        loadComponent: () =>
          import('./features/profile/presentation/pages/ayuda').then((m) => m.Ayuda),
      },
      {
        path: 'perfil/privacidad',
        loadComponent: () =>
          import('./features/profile/presentation/pages/privacidad').then((m) => m.Privacidad),
      },
    ],
  },
  {
    // Flujo de reserva (fuera del shell: pantalla completa, con botón atrás).
    path: 'viaje/destino',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/presentation/pages/destino').then((m) => m.Destino),
  },
  {
    path: 'viaje/seleccion',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/presentation/pages/seleccion-viaje').then((m) => m.SeleccionViaje),
  },
  {
    path: 'viaje/activo',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/presentation/pages/viaje-activo').then((m) => m.ViajeActivo),
  },
  {
    path: 'viaje/completado',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/presentation/pages/viaje-completado').then(
        (m) => m.ViajeCompletado,
      ),
  },
  { path: '**', redirectTo: 'welcome' },
];
